"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var qm = _interopRequireWildcard(require("@/api/qm"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t4 in e) "default" !== _t4 && {}.hasOwnProperty.call(e, _t4) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t4)) && (i.get || i.set) ? o(f, _t4, i) : f[_t4] = e[_t4]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //服务门店下拉懒加载 混入
var _default = exports.default = {
  data: function data() {
    return {
      // 所属用户
      currentPageUser: 1,
      pageSizeUser: 20,
      isLoading: false,
      hasMore: true,
      unitNameFilter: '',
      timeout: null
    };
  },
  mounted: function mounted() {
    // 组件挂载后，绑定滚动事件
    this.bindScrollEvent();
  },
  beforeDestroy: function beforeDestroy() {
    // 组件销毁前，移除滚动事件绑定
    if (this.$refs.selectScroll) {
      var scrollContainer = this.$refs.selectScroll.$el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
      if (scrollContainer) {
        scrollContainer.removeEventListener('scroll', this.handleScroll);
      }
    }
  },
  methods: {
    bindScrollEvent: function bindScrollEvent() {
      var _this = this;
      // 在下一次 DOM 更新循环结束之后执行延迟回调
      this.$nextTick(function () {
        // 获取 el-select 内部的滚动容器
        if (_this.$refs.selectScroll) {
          var scrollContainer = _this.$refs.selectScroll.$el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
          if (scrollContainer) {
            // 绑定滚动事件
            scrollContainer.addEventListener('scroll', _this.handleScroll);
          }
        }
      });
    },
    // 用户下拉 滚动懒加载
    handleScroll: function handleScroll(_ref) {
      var target = _ref.target;
      var scrollTop = target.scrollTop,
        clientHeight = target.clientHeight,
        scrollHeight = target.scrollHeight;
      if (scrollTop + clientHeight + 5 >= scrollHeight) {
        this.loadMoreOptions();
      }
    },
    loadMoreOptions: function () {
      var _loadMoreOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var nextPage, newOptions, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(this.isLoading || !this.hasMore)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.isLoading = true;
              // 异步操作，服务器获取数据
              _context.p = 2;
              nextPage = this.currentPageUser + 1; // 假设fetchMoreOptions是一个异步函数，它返回下一页的数据
              _context.n = 3;
              return this.fetchMoreOptions(nextPage, this.pageSizeUser);
            case 3:
              newOptions = _context.v;
              if (newOptions.length > 0) {
                this.userOptions = newOptions;
              } else {
                this.hasMore = false;
              }
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.isLoading = false;
            case 5:
              _context.p = 5;
              this.isLoading = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4, 5, 6]]);
      }));
      function loadMoreOptions() {
        return _loadMoreOptions.apply(this, arguments);
      }
      return loadMoreOptions;
    }(),
    loadMoreOptionsByOrg: function () {
      var _loadMoreOptionsByOrg = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var newOptions, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.loading = true;
              // 异步操作，服务器获取数据
              _context2.p = 1;
              _context2.n = 2;
              return this.fetchMoreOptionsByOrg(1, 10);
            case 2:
              newOptions = _context2.v;
              if (newOptions.length > 0) {
                this.tableOrgData = newOptions;
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.loading = false;
            case 4:
              _context2.p = 4;
              this.loading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function loadMoreOptionsByOrg() {
        return _loadMoreOptionsByOrg.apply(this, arguments);
      }
      return loadMoreOptionsByOrg;
    }(),
    loadMoreOptionsBySup: function () {
      var _loadMoreOptionsBySup = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var newOptions, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.loading = true;
              // 异步操作，服务器获取数据
              _context3.p = 1;
              _context3.n = 2;
              return this.fetchMoreOptionsBySup(1, 10);
            case 2:
              newOptions = _context3.v;
              if (newOptions.length > 0) {
                this.tableSupplierData = newOptions;
              }
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              this.loading = false;
            case 4:
              _context3.p = 4;
              this.loading = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function loadMoreOptionsBySup() {
        return _loadMoreOptionsBySup.apply(this, arguments);
      }
      return loadMoreOptionsBySup;
    }(),
    handleVisibleChange: function handleVisibleChange(visible) {
      if (visible && this.userOptions.length === 0) {
        this.loadMoreOptions();
        this.unitNameFilter = '';
      }
    },
    remoteMethodByOrg: function remoteMethodByOrg(query) {
      var _this2 = this;
      console.log(query);
      // 当用户输入搜索内容时，重置状态并加载第一页搜索结果
      this.loading = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this2.unitNameFilterByOrg = query;
        _this2.tableOrgData = [];
        _this2.loadMoreOptionsByOrg(); // 使用true作为标志位，表示是搜索操作
      }, 100);
    },
    remoteMethodBySup: function remoteMethodBySup(query) {
      var _this3 = this;
      // 当用户输入搜索内容时，重置状态并加载第一页搜索结果
      this.loading = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this3.unitNameFilterBySup = query;
        _this3.tableSupplierData = [];
        _this3.loadMoreOptionsBySup(); // 使用true作为标志位，表示是搜索操作
      }, 100);
    },
    remoteMethod: function remoteMethod(query) {
      var _this4 = this;
      // 当用户输入搜索内容时，重置状态并加载第一页搜索结果
      this.loading = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this4.unitNameFilter = query;
        _this4.currentPageUser = 0;
        _this4.userOptions = [];
        _this4.isLoading = false;
        _this4.hasMore = true;
        _this4.loadMoreOptions(); // 使用true作为标志位，表示是搜索操作
      }, 100);
    },
    // 获取服务门店-懒加载
    fetchMoreOptions: function fetchMoreOptions(page, pageSizeUser) {
      return qm.qmStoreListApi({
        page: page,
        limit: pageSizeUser,
        name: this.unitNameFilter
      });
    },
    // 获取供应商-懒加载
    fetchMoreOptionsBySup: function fetchMoreOptionsBySup(page, pageSizeUser) {
      return qm.qmSupplierListApi({
        page: page,
        limit: pageSizeUser,
        name: this.unitNameFilterBySup
      });
    },
    fetchMoreOptionsByOrg: function fetchMoreOptionsByOrg(page, pageSizeUser) {
      return qm.qmOrgListApi({
        page: page,
        limit: pageSizeUser,
        name: this.unitNameFilterByOrg
      });
    }
  }
};